import { envEnum, getEnv } from 'src/shared/utils/crossEnv';

export const getBaseUrl = (): string => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }

  return `https://${getEnv(envEnum.NODE_BACKEND_SERVER)}`;
};
